import { createSelector } from "redux-starter-kit";

export default createSelector(
  ["auth.phone_number"],
  (phoneNumber: any): any => phoneNumber
);
